<template>
    <div class="listing-payment-form__details-form">
        <div class="input-group">
            <input type="text" class="input" id="full_name" :placeholder="$t('card_details.name_on_card_placeholder')" v-model="card.holder_name">
            <label for="full_name" class="subtitle text-primary">{{ $t('card_details.name_on_card') }}</label>
            <span class="caption text-alert" v-if="cardNameError">
                {{cardNameError}}
            </span>
        </div>
        <div class="d-flex justify-content-between flex-wrap">
            <div class="input-group listing-payment-form__card-number">
                <div>
                    <div id="card-number" class="input"></div>
                    <span class="caption text-alert" v-if="cardNumberError">
                        {{cardNumberError}}
                    </span>
                </div>
                <label for="card-number" class="subtitle text-primary">{{ $t('card_details.card_number') }}</label>
            </div>
            <div class="input-group listing-payment-form__card-cvc">
                <div>
                    <div id="card-cvc" class="input"></div>
                    <span class="caption text-alert" v-if="cardCvcError">
                        {{cardCvcError}}
                    </span>
                </div>
                <label for="card-cvc" class="subtitle text-primary">CCV / CVC</label>
            </div>
            <div class="input-group listing-payment-form__card-expiry">
                <div>
                    <div id="card-expiry" class="input"></div>
                    <span class="caption text-alert" v-if="cardExpiryError">
                        {{cardExpiryError}}
                    </span>
                </div>
                <label for="card-expiry" class="subtitle text-primary">{{ $t('card_details.expiration') }}</label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            this.setUpStripe();
        },
        watch: {
            'card.holder_name': function (name, old_name) {
                if (name) {
                    this.cardNameError = '';
                }
            }
        },
        data() {
            return {
                card: {
                    cvc: '',
                    number: '',
                    expiry: '',
                    holder_name: ''
                },

                //elements
                cardNumber: '',
                cardExpiry: '',
                cardCvc: '',
                stripe: null,

                // errors
                stripeError: '',
                cardCvcError: '',
                cardExpiryError: '',
                cardNumberError: '',
                cardNameError: '',
            }
        },
        methods: {
            setUpStripe() {
                if (window.Stripe === undefined) {
                alert('Stripe V3 library not loaded!');
                } else {
                    const stripe = window.Stripe(STRIPE_KEY);
                    this.stripe = stripe;

                    const elements = stripe.elements();
                    this.cardCvc = elements.create('cardCvc');
                    this.cardExpiry = elements.create('cardExpiry');
                    this.cardNumber = elements.create('cardNumber');

                    this.cardCvc.mount('#card-cvc');
                    this.cardExpiry.mount('#card-expiry');
                    this.cardNumber.mount('#card-number');

                    this.listenForErrors();
                }
            },
            listenForErrors() {
                const vm = this;

                this.cardNumber.addEventListener('change', (event) => {
                    vm.toggleError(event);
                    vm.cardNumberError = ''
                    vm.card.number = event.complete ? true : false
                });
                    
                this.cardExpiry.addEventListener('change', (event) => {
                    vm.toggleError(event);
                    vm.cardExpiryError = ''
                    vm.card.expiry = event.complete ? true : false
                });
                
                this.cardCvc.addEventListener('change', (event) => {
                    vm.toggleError(event);
                    vm.cardCvcError = ''
                    vm.card.cvc = event.complete ? true : false
                });
            },
            toggleError (event) {
                if (event.error) {
                    this.stripeError = event.error.message;
                } else {
                    this.stripeError = '';
                }
            },
            clearElementsInputs() {
                this.cardCvc.clear()
                this.cardExpiry.clear()
                this.cardNumber.clear()
            },
            clearCardErrors() {
                this.stripeError = ''
                this.cardCvcError = ''
                this.cardExpiryError = ''
                this.cardNumberError = ''
            },	
            reset() {
                this.clearElementsInputs()
                this.clearCardErrors()
            },
            getCardData() {
                this.clearCardErrors();
                let valid = true;

                if (!this.card.number) {
                    valid = false;
                    this.cardNumberError = this.$t('card_details.card_number_required');
                }
                if (!this.card.holder_name) {
                    valid = false;
                    this.cardNameError = this.$t('card_details.name_is_required');
                }
                if (!this.card.cvc) {
                    valid = false;
                    this.cardCvcError = this.$t('card_details.cvc_required');
                }
                if (!this.card.expiry) {
                    valid = false;
                    this.cardExpiryError = this.$t('card_details.month_required');
                }
                if (this.stripeError) {
                    valid = false;
                }
                if (valid) {
                    const url = '/api/user/setup-intent';
                    this.$parent.checkingCard();

                    axios.get(url)
                    // get data
                    .then(function (response) {
                        let data = response.data.data;
                        console.log(data)
                        let secret = data.intent.client_secret;

                        (async () => {
                            const { setupIntent, error } = await this.stripe.handleCardSetup(
                                secret, this.cardNumber, {
                                    payment_method_data: {
                                        billing_details: { name: this.card.holder_name }
                                    }
                                }
                            );

                            if (error) {
                                this.$toastr.error("Unknown error occured. Please contact our support");
                                this.$parent.checkingCardFailed();
                            } else {
                                this.$parent.gotPaymentMethod(setupIntent.payment_method, this.card.holder_name);
                                // The card has been verified successfully...
                            }
                        })();
                    }.bind(this))
                    // .catch(error => {
                    //     this.$toastr.error("Failed to get users intent");
                    // })
                }
            }
        }
    }
</script>
